import { Component, OnInit } from '@angular/core';
import { NotificationsService } from './../../modules/shared/services/notifications.service'
import { StorageService } from './../../modules/shared/services/storage.service'
import { environment } from 'environments/environment';
import { UiService } from 'app/modules/shared/services/ui.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {
  shibbolethLogoutUrl;
  constructor(private notificationsService: NotificationsService,
    private storageService: StorageService,
    private router: Router,
    private uiService: UiService) { }

  ngOnInit() {
    this.notificationsService.canFetchNotification = false;
    this.shibbolethSessionLogout();
    this.clearStorage();
    this.uiService.profileUpdated();
  }

  clearStorage() {
    this.storageService.removeAll();
  }

  shibbolethSessionLogout() {
    // this.shibbolethLogoutUrl = environment.logoutUrl;
    this.router.navigate(['signin/']);
  }

  onLogin() {
    // window.location.href = 'https://shuttlesalesdemoapi.mi2.in/';
    this.router.navigate(['signin/']);
  }

}
